import React from "react";
import { ScrollView, StyleSheet } from "react-native";
import { Image } from "expo-image";

import { type EventOverview } from "@/schemas/events/EventOverview";

type Props = {
  event: EventOverview;
};

function ImageCarousel({ event }: Props): React.JSX.Element {
  const styles = StyleSheet.create({
    imageRow: {
      marginTop: 16,
    },
    scrollImage: {
      width: 100,
      height: 100,
      borderRadius: 8,
      marginRight: 8,
    },
  });

  return (
    <ScrollView
      horizontal
      showsHorizontalScrollIndicator={false}
      style={styles.imageRow}
    >
      {event.gallery.images.map((image, index) => (
        <Image
          key={index}
          source={image.uri}
          style={styles.scrollImage}
          alt={image.alt}
          accessible={true}
          accessibilityLabel={image.alt}
          accessibilityRole="image"
          contentFit="cover"
          cachePolicy="memory-disk"
        />
      ))}
    </ScrollView>
  );
}

export default ImageCarousel;
